export default {
  "error": {
    "required": "Campo é obrigatório",
    "forbiddenSymbols": "Alguns símbolos são proibidos",
    "numeric": "O campo deve ser numérico",
    "minMax": "O campo deve ter entre {0} e {1} caracteres",
    "email": "E-mail inválido",
    "amount": "Montante inválido",
    "selectedPlayer": "Selecione um jogador",
    "passwordsMismatch": "Incompatibilidade de senhas",
    "samePasswords": "As senhas novas e antigas são iguais",
    "signInUp": {
      "1": "Usuário não existe",
      "2": "senha é incorreta",
      "4": "A senha deve conter letras e dígitos com 6 a 16 caracteres",
      "5": "Por favor forneça um email válido",
      "6": "Este e-mail não está conectado a nenhuma conta.",
      "7": "O campo está vazio",
      "8": "O nome de usuário deve ter pelo menos 3 símbolos",
      "9": "Máximo de símbolos 16",
      "10": "Sem espaços",
      "11": "Aceite os termos e condições",
      "422": "Este nome de usuário já está em uso"
    }
  },
  "messages": {
    "joinClubSucces": "Pedido de adesão enviado com sucesso.",
    "createClubSuccess": "Novo clube criado com sucesso.",
    "balanceTransferSuccess": "A transferência foi feita com sucesso.",
    "waitingForData": "esperando por um dado",
    "deleteSuccess": "Excluiu a conta com sucesso",
    "changePasswordSuccess": "Senha alterada com sucesso",
    "forgotPasswordSuccess": "Sua solicitação foi enviada com sucesso",
    "counterMessage1": "Envie {0} para {1}",
    "clubWrongBalanceMessage1": "Você tem apenas {0}, mas deseja transferir o total de {1}, adicione clubBalance e tente novamente",
    "claimBackWrongMessage1": "Você deseja reivindicar de volta {0}, mas {1} tem apenas {2}",
    "counterMessage2": "Retirar {0} de {1}",
    "emailDeleteInfo": "Os e-mails serão excluídos após 30 dias",
    "subFotterText": "Termos e Condições",
    "changeRoleConfirmation": "Tem certeza de que deseja alterar as permissões do usuário de",
    "bonusSuccess": "Parabéns, você recebeu um bônus de {0}!",
    "clubPlayerRemove": "Tem certeza de sair do clube?",
    "unableExport": "Relatórios de exportação não estão disponíveis para sua conta",
    "noMessages": "Você não tem nenhuma mensagem",
    "accountPrivilegeChange": {
      "header": "Solicitação de mudança de privilégio de conta",
      "body": "Os privilégios da sua conta no {0} club foram alterados para agente {1}"
    },
    "removeFromClub": {
      "header": "Remover da Notificação do Clube",
      "body": "Sua conta foi removida do {0} club"  
    },
    "joinRequest": {
      "header": "Novo pedido de adesão",
      "body": "Você tem um novo pedido de adesão ao seu clube {0} do jogador {1}"
    },
    "joinedToClub": {
      "header": "Você se juntou a um novo clube",
      "body": "Você se juntou ao {0} clube"
    },
    "balanceUpdate": {
      "header": "Solicitação de atualização de saldo",
      "body": "Seu saldo no clube {0} foi alterado. O novo saldo é {1}"
    }
  },
  "signInUp": {
    "username": "Nome do usuário",
    "password": "Senha",
    "agreement": "Eu li {0} e {1}",
    "termsLink": "Termos e Condições",
    "privacyLink": "Política de Privacidade"
  },
  "maxClaimBack": "Máximo de reclamação por jogador: {0}",
  "cancel": "Cancelar",
  "confirm": "confirme",
  "from": "de",
  "to": "para",
  "days": "dias",
  "trade": "Comércio",
  "sendVip": "Enviar VIP",
  "pleaseWait": "Por favor, espere",
  "tradeRecord": "Registro comercial",
  "all": "tudo",
  "downline": "downline",
  "allTime": "Tempo todo",
  "last7Days": "Últimos 7 dias",
  "dialogTitleEmail": "O EMAIL",
  "vipStatusOff": "Inativado",
  "vipValidDate": "(Válido por 30 dias)",
  "logInNow": "Conecte-se agora",
  "haveAnAccount": "Ter uma conta ?",
  "dialogTitlePopUp": "Email Popup",
  "member": "Membro",
  "manager": "Gerente",
  "agent": "Agente",
  "player": "Membro",
  "userId": "ID do usuário",
  "details": "Detalhes",
  "uplineAgent": "Agente Upline",
  "buyProduct": "Comprar Produto",
  "leagueHeader": "Liga",
  "gamesCareer": "Carreira de jogos",
  "total": "Total",
  "tips": "Dicas",
  "doYouConfirm": "Você confirma",
  "game": "jogos",
  "games": "Jogos",
  "sport": "Esporte",
  "sports": "Esportes",
  "poker": "Pôquer",
  "casino": "Cassino",
  "liveCasino": "Casino ao Vivo",
  "cashout": "Saque",
  "multiBet": "Multi-aposta",
  "systemBet": "Aposta de sistema",
  "margin": "Margem",
  "theme": "Tema",
  "playerWinnings": "Ganhos do jogador",
  "winnings": "Ganhos",
  "hand": "Mãos",
  "join": "Junte-se",
  "joinClub": "Junte-se ao clube",
  "joinUnion": "Junte-se a um sindicato",
  "createAClub": "Crie um clube",
  "codeForClubCreation": "Insira o código para a criação do clube",
  "sentTo": "Enviado para",
  "tabTitle": {
    "casino": "Cassino",
    "regular": "Cassino",
    "liveCasino": "Casino ao Vivo",
    "poker": "Pôquer",
    "betting": "Esporte",
    "members": "Membros",
    "newMembers": "Novos membros",
    "trade": "Comércio",
    "tradeRecord": "Registro comercial",
    "selectDownline": "Selecione linha descendente",
    "grantCredit": "Conceder Crédito",
    "currentDownline": "Linha descendente atual"
  },
  "exchange": {
    "chips": "Fichas",
    "sapphires": "Safiras",
    "currentBalance": "Saldo Atual",
    "currentExchange": "Troca atual",
    "sapphireExchange": "{0} Safiras = {1} chips",
    "minExchangeAmount": "Valor mínimo de troca",
    "convert": "Converter"
  },
  "createUnion": "Crie uma liga",
  "grandCreditHistory": "História de Crédito",
  "soundEffects": "Efeitos sonoros",
  "memberEditing": "EDIÇÃO DE MEMBRO",
  "timeSliderName": "Tempo de Ação",
  "blindSliderName": "Blind",
  "gameLengthSliderName": "Duração do jogo",
  "buyInSliderName": "Compra em",
  "minBuyInText": "Buy-in mínimo:",
  "maxBuyInText": "Max Buy-in:",
  "newTableDialogTitle": "Nova Mesa",
  "clubLeague": "Jogos da Liga",
  "clubCapitalize": "Clube",
  "clubId": "ID do clube",
  "unionId": "Union ID",
  "agentId": "ID do agente",
  "id": "ID",
  "lv": "Lv",
  "fee": "Taxa",
  "pokerGames": "Jogos de pôquer",
  "spins": "Casino Spins",
  "bettings": "Apostas",
  "wl": "Ganhos",
  "nickname": "Apelido",
  "lastLogin": "Último Login",
  "create": "Criar",
  "createClub": "Criar Clube",
  "selectAvatar": "Selecione Avatar",
  "selectCountry": "Selecione o pais",
  "clubCreation": "Criação de Clube",
  "clubDescriptionAndRules": "Descrição e regras do clube",
  "hands": "Mãos",
  "validFor": "Valido para",
  "levelUpdate": "Atualização de nível",
  "wantToBuy": "Voce quer comprar",
  "ourSubItem": "Nosso SubItem",
  "createNewClub": "Crie um novo clube",
  "joinNewClub": "Junte-se a um clube",
  "clubName": "Nome do Clube",
  "clubNotice": "Aviso do clube",
  "content": "Conteúdo",
  "clubDisband": "Tem certeza de que deseja encerrar o clube?",
  "deleteClubMember": "Tem certeza de que deseja excluir este membro?",
  "changeRole": "Confirma a alteração da função do usuário?",
  "changeRoleFromAgent": "Os dados atuais da linha descendente serão removidos se você alterar os direitos deste agente. Você tem certeza?",
  "freeToRename": "Livre para renomear pela primeira vez",
  "welcomeMessagePart1": "Bem-vindo ao",
  "welcomeMessagePart2": "Para mais informações contacte",
  "loadingTablesList": "Carregando lista de tabelas ...",
  "notificationIsValid": "Cada notificação é válida por 24 horas",
  "jackpot": "Jackpot",
  "commision": "Comissão",
  "selectDownline": "Selecione linha descendente",
  "recruitedByTheAgent": "Marque os jogadores recrutados pelo agente",
  "levelHasExpired": "Seu nível de clube expirou, por favor, renove.",
  "grantSendOutLimit": "Conceda limite de envio para o agente",
  "currentDownline": "Linha descendente atual",
  "agentManagement": "Gestão de Agente",
  "wantToChangeDownline": "Tem certeza que deseja alterar downline de",
  "wantToRemove": "Você realmente deseja remover",
  "notifications": "Notificações",
  "quitTheClub": "Sair do clube",
  "oddDefaultFormat": "Formato padrão de probabilidades",
  "clubChipBalance": "Saldo de fichas do clube",
  "exchangeSapphires": "100 safiras = 40",
  "multipleOf100": "Insira um múltiplo integral de 100",
  "clubEditing": "Edição de clube",
  "startAnewTable": "Comece uma nova mesa",
  "change": "mudança",
  "coins": "Moedas",
  "items": "Itens",
  "sapphires": "Safiras",
  "clubHeadline1": "Não há como negar o fato de que o sucesso de um anúncio reside principalmente no título. O título deve atrair o",
  "showMore": "mostre mais",
  "clubHeadline2": "leitor e fazê-lo ler o resto do anúncio. O título deve ser simplesmente cativante e vários pontos-chave devem ser incorporados ao decidir sobre o título do anúncio. O título deve",
  "showLess": "mostre menos",
  "disbandClub": "Para confirmar a dissolução do Clube, digite a identificação do seu clube no campo de entrada.",
  "disbandUnion": "A fim de confirmar a dissolução do Union, por favor, digite o seu id Union no campo de entrada.",
  "quitTheUnion": "Para confirmar a saída do Sindicato, digite seu ID do Sindicato no campo de entrada.",
  "overall": "No geral",
  "yesterday": "Ontem",
  "past7Days": "Últimos 7 dias",
  "select": "Selecione",
  "overallWinnings": "Ganhos Gerais",
  "pokerWinnings": "Ganhos de pôquer",
  "casinoWinnings": "Ganhos de cassino",
  "bettingWinnings": "Ganhos de apostas",
  "pokerFeeAmount": "Valor da taxa de pôquer",
  "pokerFee": "Taxa de pôquer",
  "overallWL": "W / L geral",
  "pokerWL": "Pôquer W / L",
  "casinoWL": "Cassino W / L",
  "liveCasinoWL": "Casino ao Vivo W / L",
  "sportsWL": "Esportes W / L",
  "gamesPoker": "Jogos de pôquer",
  "spinsCasino": "Casino Spins",
  "deleteMember": "Excluir membro",
  "dateCreated": "Tempo de adesão",
  "chipBalance": "Saldo de fichas",
  "sent": "Enviado",
  "totalChips": "Total de fichas dos jogadores Exclui fichas em jogo",
  "yourChipsAmount": "Quantidade de suas fichas",
  "claimedBack": "Reivindicado de volta",
  "tradeCommission": "{0}% de comissão cobrada por este comércio",
  "areComingSoon": "estão chegando em breve",
  "nlh": "NLH",
  "plo": "PLO",
  "ofc": "claro",
  "ringGame": "Ring Game",
  "sng": "SNG",
  "mtt": "MTT",
  "regularMode": "Modo Regular",
  "progressiveMode": "Progressivo",
  "ultimateMode": "Final",
  "sixPlus": "6+",
  "fourCard": "4 cartas",
  "fiveCard": "5 cartas",
  "concurrent": "Concorrente",
  "sequential": "Sequencial",
  "operationSequence": "Seqüência de Operação",
  "autoStart": "Começo automático",
  "autoExtension": "Extensão Automática",
  "times": "Vezes",
  "autoOpen": "Auto Open",
  "riskManagement": "Gerenciamento de riscos",
  "multiTimeRun": "Execute-o várias vezes",
  "evChop": "Ev Chop",
  "cap": "Cap",
  "callTime": "Duração da chamada",
  "autorizedToBuyin": "Autorizado para comprar",
  "byh": "Aposte a Sua Mão",
  "gpsRestriction": "Restrição GPS",
  "ipRestriction": "Restrição de IP",
  "banChatting": "Banir bate-papo",
  "tableCost": "Custo da Tabela",
  "balance": "Saldo",
  "grantCredit": "Conceder Crédito",
  "selectDownlineText": "Marque os jogadores que deseja atribuir a esta linha descendente",
  "creditBalance": "Balanco de credito",
  "grantCreditText": "A partir daqui, você pode enviar e reivindicar as fichas do clube de volta",
  "unionClubs": "União",
  "unionJoinRequests": "Pedidos de adesão",
  "unionData": "Union Data",
  "unionEditingContent": {
    "change": "mudança",
    "label": "Nome da União",
    "notice": "Livre para renomear pela primeira vez",
    "save": "Salve ",
    "price": "Mudar o nome do clube",
    "notEnough": {
      "0": "Você não tem safiras suficientes,",
      "1": "aperte aqui",
      "2": "para comprar safiras."
    }
  },
  "information": "Em formação",
  "dataIsRecordedBasedOnUnionHeadData": "Os dados são registrados com base no fuso horário do Union Head:",
  "pokerWinLossFee": "Vitória / Perda + Taxa de Poker",
  "pokerWinLossFeeOverall": "No geral",
  "pokerWinLossFeeLastWeek": "Semana Anterior",
  "pokerWinLossFeeThisWeek": "Esta semana",
  "suspend": "Suspender",
  "remove": "Remover",
  "exportData": "Exportar dados",
  "betYourHand": {
    "combinations": "Combinações",
    "amount": "X1 / X2",
    "max": "Max",
    "nlh": {
      "0": {
        "title": "QQ Royal Flush",
        "description": "(A234567 em qualquer naipe usando ambas as cartas da mão e todas as 5 cartas da mesa)",
        "amount": "100",
        "max": "250",
        "combinations": "QQRoyalFlush"
      },
      "1": {
        "title": "Super Royal Flush",
        "description": "AKQJT em 1 naipe, usando ambas as cartas da mão e as 3 primeiras cartas da mesa",
        "amount": "30",
        "max": "50",
        "combinations": "superRoyalFlush"
      },
      "2": {
        "title": "Rubor Real",
        "description": "AKQJT em 1 naipe",
        "amount": "10",
        "max": "10",
        "combinations": "Rubor Real"
      },
      "3": {
        "title": "Straight flush",
        "description": "Qualquer straight em 1 naipe",
        "amount": "1.5",
        "max": "1.5",
        "combinations": "Straight flush"
      },
      "4": {
        "title": "Quatro de um tipo",
        "description": "Qualquer 4 de um tipo",
        "amount": "200",
        "max": "200",
        "combinations": "fourOfKind"
      },
      "5": {
        "title": "Full House Ases",
        "description": "3 Ases + 2 cartas do mesmo valor",
        "amount": "100",
        "max": "100",
        "combinations": "fullHouseAces"
      },
      "6": {
        "title": "Ace High Straight",
        "description": "Straught, Ace High AKQJT",
        "amount": "10",
        "max": "10",
        "combinations": "aceHighStraight"
      },
      "7": {
        "title": "Ace High Flush",
        "description": "Ás + Quaisquer 4 cartas do mesmo naipe",
        "amount": "10",
        "max": "10",
        "combinations": "aceHighFlush"
      },
      "8": {
        "title": "Trinca de Ases",
        "description": "3 ases",
        "amount": "10",
        "max": "10",
        "combinations": "threeOfKindAces"
      }
    },
    "plo": {
      "0": {
        "title": "QQ Royal Flush",
        "description": "A234567 em qualquer terno",
        "amount": "100",
        "max": "250",
        "combinations": "QQRoyalFlush"
      },
      "1": {
        "title": "Super Royal Flush",
        "description": "AKQJT em 1 naipe, usando ambas as cartas da mão e as 3 primeiras cartas da mesa",
        "amount": "30",
        "max": "50",
        "combinations": "superRoyalFlush"
      },
      "2": {
        "title": "Rubor Real",
        "description": "AKQJT em 1 naipe",
        "amount": "10",
        "max": "10",
        "combinations": "Rubor Real"
      },
      "3": {
        "title": "Straight flush",
        "description": "Qualquer straight em 1 naipe",
        "amount": "1.5",
        "max": "1.5",
        "combinations": "Straight flush"
      },
      "4": {
        "title": "Quatro de um tipo",
        "description": "Qualquer 4 de um tipo",
        "amount": "200",
        "max": "200",
        "combinations": "fourOfKind"
      },
      "5": {
        "title": "Full House Ases",
        "description": "3 Ases + 2 cartas do mesmo valor",
        "amount": "100",
        "max": "100",
        "combinations": "fullHouseAces"
      },
      "6": {
        "title": "Ace High Straight",
        "description": "Straught, Ace High AKQJT",
        "amount": "10",
        "max": "10",
        "combinations": "aceHighStraight"
      },
      "7": {
        "title": "Ace High Flush",
        "description": "Ás + Quaisquer 4 cartas do mesmo naipe",
        "amount": "10",
        "max": "10",
        "combinations": "aceHighFlush"
      }
    }
  },
  "exportRecord": "Exportar registro",
  "exportDate": "Data de Exportação",
  "pleaseEnterValidEmail": "por favor digite um email válido",
  "playerData": "PlayerData",
  "sapphireStatement": "Declaração Safira",
  "tradeRecords": "Registros comerciais",
  "upgradeToJoinText": "Seu clube deve estar no Nível 2 ou superior para ingressar em um sindicato",
  "upgradeToCreateText": "Seu clube deve estar no Nível 2 ou superior para criar um Sindicato",
  "clubDataHelp": [
    ["No geral", "Exibe dados desde que o usuário ingressou no clube"],
    ["Últimos 7 dias","Exibe dados dos últimos 7 dias"],
    ["Selecione", "Exibe dados das datas selecionadas."],
    ["Ganhos Gerais", "Exibe dados de quantas fichas o usuário ganhou / perdeu em todos os jogos."],
    ["Ganhos de pôquer", "Exibe dados de quantas fichas o usuário ganhou / perdeu durante os jogos de Poker."],
    ["Ganhos de cassino", "Exibe dados de quantas fichas o usuário ganhou / perdeu durante os jogos do Casino."],
    ["Valor da taxa", "Mostra a quantidade de Taxas de Pôquer dada ao clube"]
  ],
  "footer": {
    "items": {
      "home": "Home",
      "shop": "fazer compras",
      "career": "Carreira",
      "profile": "Perfil",
      "messages": "Mensagens",
      "settings": "Configurações",
      "data": "Dados",
      "members": "Membros",
      "counter": "Contador"
    }
  },
  "agentDetails": {
    "memberAmount": "Quantidade de membro {0}"
  },
  "language": {
    "en": "Inglês",
    "tur": "turco",
    "id": "indonésio",
    "de": "alemão",
    "ar": "árabe",
    "fr": "francês",
    "pt": "Português"
  },
  "dialog": {
    "tutorial": "Tutorial",
    "createClub": "Criar Clube",
    "createAClub": "Crie um clube",
    "joinClub": "Junte-se ao clube",
    "selectAvatar": "Selecione avatar",
    "selectCountry": "Selecione o pais",
    "coins": "Moedas",
    "notification": "Notificação",
    "sapphires": "Safiras",
    "exchange": "Troca",
    "editClub": "Edição de clube",
    "disbandClub": "Dissolver o clube",
    "disbandUnion": "Dissolver a Liga",
    "deleteMember": "Confirmação",
    "editMemberInfo": "Editar informações do membro",
    "changeRole": "Confirmação",
    "mission": "Missões",
    "unionNotice": "Aviso da Liga",
    "joinUnion": "Junte-se a uma liga",
    "createUnion": "Crie uma união",
    "createLabel": "Digite o nome da união",
    "joinLabel": "Insira o ID da união",
    "unionAuthority": "Autoridade",
    "selectAuthority": {
      "text": "Selecione a autoridade para criar mesas de Poker",
      "current": "Proprietários e gerentes de clube atuais",
      "all": "Todos os proprietários e gerentes de clube"
    },
    "unionConfirm": "confirme",
    "unionTerms": {
      "one": "1. Apenas Clubes de duas estrelas ou mais podem criar ou aderir a um Sindicato.",
      "two": "2. Depois de criar ou ingressar em um Sindicato, os Chips retidos em seu clube ainda estarão disponíveis naquele Sindicato específico. No entanto, os chips detidos pelos agentes e jogadores serão removidos",
      "agreement": "Eu li os termos e condições"
    },
    "clubDetails": "Detalhes do clube",
    "upgradeToCreate": "Não é possível criar uma união",
    "upgradeToJoin": "Não posso aderir a um sindicato",
    "unionConfirmation": "Detalhes da União",
    "clubConfirmation": "Detalhes do clube",
    "renewLevel": "Não é possível criar a mesa",
    "agentDetails": "Detalhes do Agente",
    "quitTheUnion": "Saia da Liga",
    "export": "Exportar",
    "notEnoughFunds": "Fundos insuficientes",
    "memberMenu": "Detalhes do clube",
    "betYourHand": "Probabilidades",
    "enterAmount": "Por favor insira o valor"
  },
  "settings": {
    "text": "Configurações",
    "twoStepVerification": "Verificação em duas etapas",
    "changePassword": "Mudar senha",
    "changeEmail": "Mude o e-mail",
    "languages": "línguas",
    "avatar": "Avatar",
    "details": "Detalhes",
    "linkEmail": "Vincule seu e-mail",
    "language": "Língua",
    "select": "Selecione",
    "logOut": "Sair"
  },
  "clubLevelName": {
    "1": "One Star Club",
    "2": "Clube Duas Estrelas",
    "3": "Clube Três Estrelas",
    "4": "Four Star Club",
    "5": "Five Star Club",
    "6": "Six Star Club",
    "7": "Seven Star Club",
    "8": "Eight Star Club",
    "9": "Clube Nove Estrelas",
    "10": "Ten Star Club",
    "11": "Super Star Club"
  },
  "changePassword": {
    "text": "Mudar senha",
    "current": "senha atual",
    "new": "Nova senha",
    "repeat": "Confirme a Senha",
    "confirm": "confirme"
  },
  "linkEmail": {
    "text": "Vincule seu e-mail",
    "writeYourEmail": "Escreva aqui o seu email e iremos enviar-lhe o código de verificação",
    "emailAddress": "Endereço de e-mail",
    "resendCode": "Reenviar código de verificação",
    "checkYourMail": "Verifique o seu código de verificação na caixa de correio, pode ser a caixa de spam",
    "verificationCode": "Código de verificação",
    "unverifiedCode": "Código de verificação incorreto",
    "alreadyLinked": "Já Ligado"
  },
  "passwordRecovery": {
    "emailField": "Endereço de e-mail",
    "title": "Recuperação de senha",
    "description": "Escreva o seu endereço de e-mail que você usou no registro.",
    "sendEmail": "Enviar email",
    "successDescription": "Nós lhe enviamos uma nova senha temporária. Você pode usá-lo para entrar no jogo. Após fazer o login, você pode alterar a senha no menu Configurações do jogo",
    "goBack": "Voltar"
  },
  "tutorial": {
    "text": "Tutorial",
    "accountSettings": "Configurações da conta",
    "leagueGames": "Jogos da Liga",
    "clubs": "Clubs",
    "shop": "fazer compras",
    "dailyBonus": "Bônus diário",
    "accountLevelsAndXP": "Níveis de conta e XP",
    "friendInvite": "Convite de amigo"
  },
  "about": {
    "text": "Sobre",
    "gameRules": "Regras do jogo",
    "contactInfo": "Informação de contato",
    "termsAndConditions": "Termos e Condições",
    "privacyPolicy": "Política de Privacidade"
  },
  "leaderboard": {
    "text": "Entre os melhores",
    "remaining": "Tempo restante",
    "rank": "Classificação",
    "name": "Nome",
    "points": "Seus pontos",
    "reward": "Recompensa",
    "daily": "diariamente",
    "weekly": "semanal",
    "monthly": "por mês"
  },
  "leaderboardInfo": {
    "text": "Informações do placar",
    "hints": "Dicas",
    "rewards": "Recompensas"
  },
  "leaderboardHints": {
    "text": "Dicas",
    "rule": "Ao jogar na liga ou no clube, o jogador ganha pontos e participa das tabelas de classificação. Ao final do cronômetro, os jogadores que estiverem entre os dez primeiros receberão recompensas.",
    "hintsText": {
      "0": {
        "header": "Dica 1.",
        "text": "Você pode ganhar pontos na Tabela de Líderes jogando pôquer, jogos de cassino e fazendo apostas na liga e nos clubes."
      },
      "1": {
        "header": "Dica 2.",
        "text": "Jogar jogos e fazer apostas em clubes dará a você mais pontos do que jogos da liga"
      },
      "2": {
        "header": "Dica 3.",
        "text": "Os pontos são definidos pela quantidade de dinheiro que você ganha, uma grande aposta dará a você uma recompensa maior e também muitos pontos."
      },
      "3": {
        "header": "Dica 4.",
        "text": "Seus pontos serão zerados quando o cronômetro terminar. Mas se você não conseguiu ficar entre os 20 primeiros nas tabelas de classificação diárias, você ainda terá a chance de aumentar esses pontos e entrar no Top 20 nas tabelas de classificação semanais ou mensais."
      }
    }
  },
  "level": {
    "currentXp": "XP atual",
    "requiredXp": "XP Requerido",
    "gainXp": "Jogue pôquer, cassino ou faça para ganhar XP e subir de nível",
    "accountLevel": "Nível da conta",
    "levelRewards": "Recompensas de nível {0}"
  },
  "shop": {
    "text": "fazer compras",
    "coins": {
      "text": "Moedas"
    },
    "items": {
      "text": "Itens",
      "silverCard": "Cartão Siver",
      "goldCard": "Cartão dourado",
      "platinumCard": "Cartão Platinum",
      "avatars": "Avatares",
      "emojis": "Emojis"
    },
    "sapphires": {
      "text": "Safiras"
    },
    "mostPopular": "Mais popular",
    "bestValue": "Melhor valor"
  },
  "support": {
    "text": "Apoio, suporte"
  },
  "time": {
    "s15": "15s",
    "s20": "20s",
    "s30": "30s"
  },
  "number": {
    "one": "1",
    "onePointFive": "1,5",
    "two": "2",
    "twoPointFive": "2,5",
    "three": "3",
    "fout": "4",
    "five": "5",
    "six": "6"
  },
  "dash": {
    "claimBack": "Receber",
    "buyIn": "Compra em"
  },
  "button": {
    "ok": "Está bem",
    "confirm": "confirme",
    "cancel": "Cancelar",
    "claimBack": "Receber",
    "sendOut": "Enviar",
    "send": "Mandar",
    "oneMore": "Mais um",
    "buy": "Comprar",
    "done": "Feito",
    "submit": "Enviar",
    "quit": "Saia do clube",
    "sapphire": "Safira",
    "select": "Selecione",
    "save": "Salve ",
    "sendVip": "Enviar VIP",
    "upgrade": "Melhoria",
    "close": "Fechar",
    "create": "Crio",
    "join": "Junte-se",
    "apply": "Aplique",
    "claim": "Afirmação"
  },
  "header": {
    "clubData": "Dados do clube",
    "clubDetails": "Detalhes do clube",
    "clubChips": "Chips do clube",
    "clubRating": "Classificação do clube",
    "title": "Título"
  },
  "playerMenu": {
    "playerMenuTitle": "Detalhes do jogador",
    "trade": "Registro comercial",
    "jackpot": "Jackpot",
    "quit": "Saia do clube"
  },
  "agentMenu": {
    "agentMenuTitle": "Detalhes do Agente",
    "grantCredit": "Conceder Crédito"
  },
  "career": {
    "items": {
      "poker": "Mãos",
      "sportsbook": "Apostas",
      "casino": "Apostas"
    },
    "periods": {
      "day": "dia",
      "month": "mês",
      "year": "ano"
    },
    "range": {
      "all": "Tempo todo",
      "lastWeek": "Últimos 7 dias",
      "purchase": "Compre um cartão Gold ou superior para dados mais detalhados"
    },
    "reports": {
      "game": "jogos",
      "hand": "Mão"
    },
    "menu": {
      "filters": "Filtros"
    },
    "menuRow": {
      "all": "Tudo",
      "poker": "Pôquer",
      "casino": "Cassino",
      "betting": "Apostas"
    }
  },
  "options": {
    "clubChips": "{1} Chips {0}",
    "newMessage": "Notificações",
    "buyLevel": "Classificação do clube LVL {0}",
    "promotion": "Promoção",
    "disband": "Dissolver o clube",
    "leftDays": "(Faltam {0} dias)",
    "grandCredit": "História de Crédito",
    "quit": "Saia do clube"
  },
  "union": {
    "clubs": "Union Clubs",
    "requests": "Pedidos de adesão",
    "data": "Union Data",
    "authority": "Autoridade para criar mesas de pôquer",
    "disband": "Dissolver a União",
    "quit": "Saia do Union"
  },
  "club": {
    "text": "Clube",
    "poker": "Pôquer",
    "betting": "Apostas",
    "casino": "Cassino",
    "games": {
      "poker": {
        "admin": "Atualmente, os jogos de cassino não estão disponíveis. Para disponibilizá-lo, renove sua classificação do clube",
        "member": "Atualmente não há mesas de pôquer disponíveis"
      },
      "casino": {
        "admin": "Atualmente, os jogos de cassino não estão disponíveis. Para disponibilizá-lo, renove sua classificação do clube",
        "member": "Jogos de cassino não estão disponíveis no momento"
      },
      "betting": {
        "admin": "Atualmente, as apostas não estão disponíveis. Para disponibilizá-lo, renove sua classificação do clube",
        "member": "As apostas não estão disponíveis no momento",
        "enterText": "Pressione o botão para entrar na seção de esportes",
        "goToSports": "Vá para esportes"
      },
      "renew": "Renovar"
    }
  },
  "clubItems": {
    "options": "Opções do clube",
    "notifications": "Notificações",
    "members": "Detalhes do membro",
    "counter": "Contador",
    "tradeRecords": "Registros comerciais",
    "memberDetails": "Detalhes do membro",
    "clubRatings": "Classificações do clube",
    "claimBack": "Reclamar de volta",
    "sendOut": "Enviar",
    "data": "Dados do clube",
    "union": "União",
    "unionEditing": "Edição de Liga",
    "agentMenu": "Menu do Agente"
  },
  "memberDetails": {
    "trackPlayer": "Track Player",
    "roleSelection": "Seleção de Função",
    "clubRatings": "Classificações do clube",
    "editMemberInfo": {
      "alias": "Adicionar Alias",
      "notes": "Adicionar notas"
    }
  },
  "tradeDirection": {
    "sent": "Enviado para:",
    "claimedBack": "Reivindicado de:"
  },
  "members": "Membros",
  "newMembers": "Novos membros",
  "betting": "Apostas",
  "title": "Título",
  "chips": "Fichas",
  "currentPassword": "senha atual",
  "newPassword": "Nova senha",
  "repeatPassword": "Repita a senha",
  "email": "O email",
  "login": "Conecte-se",
  "version": "Versão",
  "loginObj": {
    "text": "Não tem uma conta?",
    "link": "Registrar agora!"
  },
  "registerObj": {
    "text": "já tem uma conta?",
    "link": "assinar em"
  },
  "forgotPassword": "Esqueceu a senha",
  "loginBonus": "Bônus de login",
  "insurance": "Seguro",
  "totalPokerFees": "Total de taxas de pôquer",
  "pokerFees": "Taxas de pôquer",
  "totalWinnings": "Ganhos totais",
  "winningsLastWeek": "Ganhos na semana passada",
  "winningsThisweek": "Ganhos esta semana",
  "downlinesChips": "Fichas de Downline",
  "chipsInPlay": "Fichas em jogo",
  "lastWeek": "Semana Anterior",
  "currentWeek" : "Semana atual",
  "invalidEmail": "E-mail inválido",
  "signIn": "Assinar em",
  "signUp": "Inscrever-se",
  "aboutUs": "Sobre nós",
  "edit": "Editar",
  "country": "País",
  "nameOfTable": "Nome da Mesa",
  "actionTime": "Tempo de Ação",
  "blinds": "Cortinas",
  "min": "Min",
  "max": "Max",
  "month": "Mês",
  "day": "Dia",
  "week": "Semana",
  "filter": "Filtro",
  "downlines":"Downlines",
  "ownerChipsAmount" : "Quantidade de fichas do proprietário",
  "totalPlayersChipsAmount": "Total de fichas do jogador exclui fichas em jogo",
  "agentChipsAmount": "Quantidade de fichas de agente",
  "youDontHaveAnyMessages": "Você não tem nenhuma mensagem",
  "enterTheClubID": "Insira o ID do clube",
  "returnToClubLobby": "Retornar ao lobby do clube",
  "areYouSureYouWantToQuitTheClub": "Tem certeza que deseja sair do clube?",
  "casinoIsLoading": "Casino está carregando",
  "sportsIsLoading": "Esportes carregando",
  "tableIsLoading": "A mesa está carregando",
  "dearCustomer": "Estimado cliente",
  "removeFromClubNotification": "Remover da Notificação do Clube",
  "dear": "Querido {0}",
  "feedbackHistory": "Histórico de feedback",
  "writeTheReportHere": "Escreva o relatório aqui",
  "youCanWriteYourSuggestions": "Você pode escrever suas sugestões e relatórios de erros para nossa equipe de suporte. Ficaremos felizes em ajudá-lo.",
  "hello": "Olá",
  "titleIsLimitedToLetters" : "O título está limitado a 20 letras"
};
